/**
 * 登录令牌的存放位置。
 *
 * 放 localStorage：后台是内部工具，刷新页面不该丢登录；令牌本身有服务端有效期，
 * 过期就得重新登录。存不进去（隐私模式、被策略拦下）时要如实返回失败，
 * 让调用方提示「这次登录不会保持」，而不是假装登录状态持久化了。
 */

const TOKEN_KEY = "stonelab.admin.token";

export interface TokenStorage {
  read(): string | null;
  /** 返回是否真的写进去了。 */
  write(token: string): boolean;
  clear(): void;
}

export function createTokenStorage(storage: Storage): TokenStorage {
  return {
    read(): string | null {
      try {
        const value = storage.getItem(TOKEN_KEY);
        return value === null || value.length === 0 ? null : value;
      } catch {
        return null;
      }
    },

    write(token: string): boolean {
      try {
        storage.setItem(TOKEN_KEY, token);
        return true;
      } catch {
        return false;
      }
    },

    clear(): void {
      try {
        storage.removeItem(TOKEN_KEY);
      } catch {
        // 清不掉不影响继续用：令牌会随会话过期失效。
      }
    },
  };
}
